import { DefaultUrlSerializer, Params, UrlTree } from '@angular/router';

// Query param không có giá trị (?searchTerm=, ?category) không mang nghĩa với app: mọi nơi đọc param đều kiểm tra
// truthy. Bỏ chúng ở parse (URL đi vào: lần điều hướng đầu dùng replaceUrl => thanh địa chỉ được làm sạch luôn)
// và ở serialize (navigate, routerLink href, history). Server 301 các URL này trước khi SSR (server.ts).
export class CleanUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    return withoutEmptyQueryParams(super.parse(url));
  }

  override serialize(tree: UrlTree): string {
    return super.serialize(withoutEmptyQueryParams(tree));
  }
}

const isEmpty = (value: unknown) => value === '' || value === null || value === undefined;

function withoutEmptyQueryParams(tree: UrlTree): UrlTree {
  let changed = false;
  const queryParams: Params = {};
  for (const [name, value] of Object.entries(tree.queryParams)) {
    const kept = Array.isArray(value) ? value.filter(v => !isEmpty(v)) : value;
    const keep = name !== '' && (Array.isArray(kept) ? kept.length > 0 : !isEmpty(kept));
    if (!keep || (Array.isArray(value) && kept.length !== value.length)) changed = true;
    if (keep) queryParams[name] = kept;
  }
  return changed ? new UrlTree(tree.root, queryParams, tree.fragment) : tree;
}
